export default {
    STYLES: [
        'large',
        'floating',
        'flat'
    ],
    WAVES: [
        'light',
        'red',
        'yellow',
        'orange',
        'purple',
        'green',
        'teal'
    ],
    SIZES: [
        's',
        'm',
        'l'
    ],
    PLACEMENTS: [
        'left',
        'center',
        'right'
    ],
    SCALES: [
        'big',
        'small'
    ],
    ICON_SIZES: [
        'tiny',
        'small',
        'medium',
        'large'
    ]
};